export const ADMIN_INSPECTION_JOB_INIT = 'ADMIN_INSPECTION_JOB_INIT';

//  ******* Inspection Job GET *******

export const ADMIN_INSPECTION_JOB_FETCH_BEGIN = 'ADMIN_INSPECTION_JOB_FETCH_BEGIN';
export const ADMIN_INSPECTION_JOB_FETCH_SUCCESS = 'ADMIN_INSPECTION_JOB_FETCH_SUCCESS';
export const ADMIN_INSPECTION_JOB_FETCH_FAIL = 'ADMIN_INSPECTION_JOB_FETCH_FAIL';

// ******** Quotation GET ********

export const ADMIN_INSPECTION_QUOTE_FETCH_BEGIN = 'ADMIN_INSPECTION_QUOTE_FETCH_BEGIN';
export const ADMIN_INSPECTION_QUOTE_FETCH_SUCCESS = 'ADMIN_INSPECTION_QUOTE_FETCH_SUCCESS';
export const ADMIN_INSPECTION_QUOTE_FETCH_FAIL = 'ADMIN_INSPECTION_QUOTE_FETCH_FAIL';

//  ******* Quotation POST *******

export const ADMIN_INSPECTION_QUOTE_SUBMIT_BEGIN = 'ADMIN_INSPECTION_QUOTE_SUBMIT_BEGIN';
export const ADMIN_INSPECTION_QUOTE_SUBMIT_SUCCESS = 'ADMIN_INSPECTION_QUOTE_SUBMIT_SUCCESS';
export const ADMIN_INSPECTION_QUOTE_PUBLISH_SUCCESS = 'ADMIN_INSPECTION_QUOTE_PUBLISH_SUCCESS';
export const ADMIN_INSPECTION_QUOTE_SUBMIT_FAIL = 'ADMIN_INSPECTION_QUOTE_SUBMIT_FAIL';

//  ******* Quotation DELETE PATCH ********

export const ADMIN_INSPECTION_QUOTE_DELETE_BEGIN = 'ADMIN_INSPECTION_QUOTE_DELETE_BEGIN';
export const ADMIN_INSPECTION_QUOTE_DELETE_SUCCESS = 'ADMIN_INSPECTION_QUOTE_DELETE_SUCCESS';
export const ADMIN_INSPECTION_QUOTE_DELETE_FAIL = 'ADMIN_INSPECTION_QUOTE_DELETE_FAIL';

//  ******* Quotation Status PATCH ********

export const ADMIN_INSPECTION_STATUS_UPDATE_BEGIN = 'ADMIN_INSPECTION_STATUS_UPDATE_BEGIN';
export const ADMIN_INSPECTION_STATUS_UPDATE_SUCCESS = 'ADMIN_INSPECTION_STATUS_UPDATE_SUCCESS';
export const ADMIN_INSPECTION_STATUS_UPDATE_FAIL = 'ADMIN_INSPECTION_STATUS_UPDATE_FAIL';

// ******* Invoices Download POST ********
export const ADMIN_INSPECTION_INVOICE_DOWNLOAD_BEGIN = 'ADMIN_INSPECTION_INVOICE_DOWNLOAD_BEGIN';
export const ADMIN_INSPECTION_INVOICE_DOWNLOAD_SUCCESS = 'ADMIN_INSPECTION_INVOICE_DOWNLOAD_SUCCESS';
export const ADMIN_INSPECTION_INVOICE_DOWNLOAD_FAIL = 'ADMIN_INSPECTION_INVOICE_DOWNLOAD_FAIL';

// ******* Invoices Create POST ********
export const ADMIN_INSPECTION_INVOICE_CREATE_BEGIN = 'ADMIN_INSPECTION_INVOICE_CREATE_BEGIN';
export const ADMIN_INSPECTION_INVOICE_CREATE_SUCCESS = 'ADMIN_INSPECTION_INVOICE_CREATE_SUCCESS';
export const ADMIN_INSPECTION_INVOICE_CREATE_FAIL = 'ADMIN_INSPECTION_INVOICE_CREATE_FAIL';

// ******* Invoices GET ********
export const ADMIN_INSPECTION_INVOICES_FETCH_BEGIN = 'ADMIN_INSPECTION_INVOICES_FETCH_BEGIN';
export const ADMIN_INSPECTION_INVOICES_FETCH_SUCCESS = 'ADMIN_INSPECTION_INVOICES_FETCH_SUCCESS';
export const ADMIN_INSPECTION_INVOICES_FETCH_FAIL = 'ADMIN_INSPECTION_INVOICES_FETCH_FAIL';

// ******* Invoice GET ********
export const ADMIN_INSPECTION_INVOICE_FETCH_BEGIN = 'ADMIN_INSPECTION_INVOICE_FETCH_BEGIN';
export const ADMIN_INSPECTION_INVOICE_FETCH_SUCCESS = 'ADMIN_INSPECTION_INVOICE_FETCH_SUCCESS';
export const ADMIN_INSPECTION_INVOICE_FETCH_FAIL = 'ADMIN_INSPECTION_INVOICE_FETCH_FAIL';

// ******* Invoice PUT ********
export const ADMIN_INSPECTION_INVOICE_UPDATE_BEGIN = 'ADMIN_INSPECTION_INVOICE_UPDATE_BEGIN';
export const ADMIN_INSPECTION_INVOICE_UPDATE_SUCCESS = 'ADMIN_INSPECTION_INVOICE_UPDATE_SUCCESS';
export const ADMIN_INSPECTION_INVOICE_UPDATE_FAIL = 'ADMIN_INSPECTION_INVOICE_UPDATE_FAIL';

// ******* Invoice DELETE ********
export const ADMIN_INSPECTION_INVOICE_DELETE_BEGIN = 'ADMIN_INSPECTION_INVOICE_DELETE_BEGIN';
export const ADMIN_INSPECTION_INVOICE_DELETE_SUCCESS = 'ADMIN_INSPECTION_INVOICE_DELETE_SUCCESS';
export const ADMIN_INSPECTION_INVOICE_DELETE_FAIL = 'ADMIN_INSPECTION_INVOICE_DELETE_FAIL';

//  ******* Job Update PUT ********

export const ADMIN_INSPECTION_JOB_UPDATE_BEGIN = 'ADMIN_INSPECTION_JOB_UPDATE_BEGIN';
export const ADMIN_INSPECTION_JOB_UPDATE_SUCCESS = 'ADMIN_INSPECTION_JOB_UPDATE_SUCCESS';
export const ADMIN_INSPECTION_JOB_UPDATE_FAIL = 'ADMIN_INSPECTION_JOB_UPDATE_FAIL';

export const ADMIN_INSPECTION_JOB_RESET = 'ADMIN_INSPECTION_JOB_RESET';
